<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-01",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 42,
      nextPage: '/questionnaire/section3/2',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        mainTitle: 'In the past month, your diet:',
        btn: [
          [
            {
              text: 'Vegan',
              operation: 'remove product FM-EPOIL-101 & remove product FM-CRANB-101 & remove product FM-MCPEP-101 & flag3-1 Vegan & flag1-4_Pregnancy_add reminder 8 & flag1-4_Lactation_add reminder 9'
            },{
              text: 'Pescatarian',
              operation: 'remove product FM-EPOIL-101 & remove product FM-CRANB-101 & flag3-1 Pescatarian & flag1-4_None_add reminder 5'
            }
          ],[
            {
              text: 'Vegetarian(Prefer plant-based)',
              operation: 'remove product FM-EPOIL-101 & remove product FM-CRANB-101 & remove product FM-MCPEP-101 & & flag3-1 Vegan & flag1-4_Pregnancy_add reminder 8 & flag1-4_Lactation_add reminder 10'
            },{
              text: 'Anything goes',
              operation: 'flag3-1 Anything'
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
